import { component$, useContext } from '@builder.io/qwik';
import { ArticleContext } from '~/contexts/ArticleContext';
import { useMainCategoryPath } from '~/utilities/useMainCategoryPath';

export default component$(() => {
  const article = useContext(ArticleContext);
  const mainCategoryPath = useMainCategoryPath();

  if (!article) return <></>;

  const mainCategory = article.mainCategory;

  return (
    <a
      class='font-group-normal underline italic !font-[700]'
      href={mainCategoryPath}
    >
      {mainCategory?.displayName}
    </a>
  );
});
